import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';

const DeleteConfirmationModal = ({ open, onClose, onConfirm, itemName }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirmar Exclusão</DialogTitle>
            <DialogContent>
                <Typography>
                    Tem certeza que deseja excluir "{itemName}"? Esta ação não poderá ser desfeita.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained">
                    Excluir
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationModal; 